import React, { useContext, useState } from 'react'

import withView from 'core/components/withView'
import useFetch from 'core/hooks/use-fetch'
import { GlobalContext } from 'core/contexts/global-context'
import { getPostBackgrounds } from 'core/helpers/wp-data-helpers'

import Window from 'core/components/Window'
import PressHeader from './PressHeader'
import PressGallery from './PressGallery'
import PressTable from 'press/components/PressTable'
import PressList from 'press/components/PressList'

let key = 'init'
const Press = props => {
  const global = useContext(GlobalContext)

  const [open, setOpen] = useState(true)
  const [width, setWidth] = useState(null)
  const altLayout = 'list'
  const defaultLayout = 'gallery'
  const [layout, setLayout] = useState(defaultLayout)

  const altOrder = 'asc'
  const defaultOrder = 'des'
  const [sort, setSort] = useState({ data: null })

  useFetch('/page/press', {
    onSuccess: data => global.setBackground(getPostBackgrounds(data))
  })

  const keys = {
    date: ['post_date'],
    type: ['fields', 'article_type'],
    publication: ['fields', 'outlet']
  }

  const getSearchParams = () => {
    const searchParams = new URLSearchParams(props.location.search)
    return {
      // sort: searchParams.get('sort') || 'date',
      // order: searchParams.get('order') || defaultOrder,
      filter: searchParams.get('filter') || '',
      value: searchParams.get('value') || ''
    }
  }

  const setSearchParams = params => {
    const searchParams = new URLSearchParams()
    for (let [key, value] of Object.entries(params)) {
      value.length > 0 && searchParams.set(key, value)
    }
    props.history.push(`?${searchParams.toString()}`)
  }

  const sortData = (params, data) => {
    /**
     * We're not sorting right now for Press.
     */
    setSort({ data })

    // const reorder = [...data].sort((a, b) => {
    //   for (let i = 0; i < keys[params.sort].length; i++) {
    //     a = a[keys[params.sort][i]] ? a[keys[params.sort][i]] : ' '
    //     b = b[keys[params.sort][i]] ? b[keys[params.sort][i]] : ' '
    //   }
    //   return params.order === defaultOrder ? b.localeCompare(a) : a.localeCompare(b)
    // })
    // setSort({ data: reorder })
  }

  const filterData = (params, data) => {
    const filtered = [...data].filter(f => {
      for (let i = 0; i < keys[params.filter].length; i++) {
        f = f[keys[params.filter][i]] ? f[keys[params.filter][i]] : ' '
        f = keys[params.filter][i] === 'post_date' ? `${f.slice(5, 7)}.${f.slice(0, 4)}` : f
      }
      return params.value === f.toLowerCase()
    })
    return filtered
  }

  const { loading, error, data } = useFetch('/press', {
    onSuccess: data => {
      const params = getSearchParams()
      // props.location.search.length === 0 && setSearchParams(params)
      sortData(params, params.filter.length > 0 ? filterData(params, data) : data)
    }
  })

  const close = e => {
    setOpen(false)
  }

  if (props.location && props.location.key && props.location.key !== key && !open) {
    setOpen(true)
  }
  if (props.location.key) key = props.location.key

  const toggleLayout = () => {
    const toggle = layout === defaultLayout ? altLayout : defaultLayout
    setLayout(toggle)
  }

  const toggleSort = e => {
    const params = getSearchParams()

    const reorder =
      e.target.classList.contains('is-active') && params.order === defaultOrder
        ? altOrder
        : defaultOrder
    const newParams = { ...params, sort: e.target.id, order: reorder }
    setSearchParams(newParams)
    sortData(newParams, sort.data)
  }

  const toggleFilter = (e, value) => {
    e.stopPropagation()

    const params = getSearchParams()

    const newParams = !value
      ? { ...params, filter: '', value: '' }
      : { ...params, filter: 'type', value }

    setSearchParams(newParams)
    const newData = !value ? data : filterData(newParams, data)
    sortData(newParams, newData)
  }

  const getColumnClass = w => {
    if (!w) return ''
    if (w < 450) return 'mod-col-1'
    if (w < 600) return 'mod-col-2'
    if (w < 800) return 'mod-col-3'
    if (w < 1000) return 'mod-col-4'
    return 'mod-col-5'
  }

  if (error) return <p>An error happened: {error.message}</p>

  return (
    <div className={props.className}>
      <Window
        resizable
        open={open}
        loading={loading}
        mobile={global.mobile}
        fullscreen={global.mobile}
        maxWidth={1200}
        onResizeStop={data => {
          setWidth(parseInt(data.width, 10))
        }}
        onLoad={data => {
          setWidth(parseInt(data.width, 10))
        }}
        titlebar={{
          title: props.title,
          close: global.mobile ? null : close,
          layout: layout,
          toggleLayout: toggleLayout
        }}
      >
        <div className={`press-wrapper ${getColumnClass(width)}`}>
          <PressHeader items={sort.data || []} width={width} toggleFilter={toggleFilter} />
          {(function () {
            if (layout === 'gallery') {
              return (
                <PressGallery
                  width={width}
                  items={sort.data || []}
                  toggleFilter={toggleFilter}
                  toggleSort={toggleSort}
                  getColumnClass={getColumnClass}
                />
              )
            }

            if (width <= 600) return <PressList items={sort.data} toggleFilter={toggleFilter} />
            return <PressTable items={sort.data || []} toggleFilter={toggleFilter} />
          })()}
        </div>
      </Window>
    </div>
  )
}

export default withView(Press)
